import { jsxs as t, jsx as C } from "react/jsx-runtime";
const H = ({
  size: i,
  className: o
}) => /* @__PURE__ */ t(
  "svg",
  {
    className: o,
    fill: "none",
    height: i,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M23.8496 11.7842C23.8496 5.43296 18.7008 0.28418 12.3496 0.28418C5.99839 0.28418 0.849609 5.43296 0.849609 11.7842C0.849609 17.1772 4.56273 21.7027 9.57167 22.9456V15.2986H7.20037V11.7842H9.57167V10.2699C9.57167 6.35572 11.3431 4.54148 15.186 4.54148C15.9146 4.54148 17.1718 4.68454 17.6861 4.82714V8.01264C17.4147 7.98412 16.9432 7.96986 16.3576 7.96986C14.472 7.96986 13.7434 8.68424 13.7434 10.5413V11.7842H17.4998L16.8544 15.2986H13.7434V23.2C19.4377 22.5123 23.8501 17.6639 23.8501 11.7842H23.8496Z",
          fill: "currentColor",
          id: "Initiator"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M16.8537 15.2986L17.4991 11.7842H13.7427V10.5413C13.7427 8.68426 14.4714 7.96988 16.3569 7.96988C16.9425 7.96988 17.414 7.98414 17.6854 8.01266V4.82716C17.1711 4.6841 15.9139 4.5415 15.1853 4.5415C11.3425 4.5415 9.57101 6.35574 9.57101 10.2699V11.7842H7.19971V15.2986H9.57101V22.9456C10.4606 23.1664 11.3912 23.2842 12.3489 23.2842C12.8204 23.2842 13.2855 23.2552 13.7423 23.2V15.2986H16.8533H16.8537Z",
          fill: "white",
          id: "F"
        }
      )
    ]
  }
);
export {
  H as Facebook
};
